import { connect } from "react-redux";
import CreateBrand from "./CreateBrand";
import { bindActionCreators } from "redux";
import { createDeleteBrand } from "services/redux/businessItems/action";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createDeleteBrand,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CreateBrand);
